import { ENTRY } from '~/core/paths'

/**
 * Top-level destinations of the signed-in app, in the Agent's vocabulary.
 *
 * The values are the application's routes. They used to be the Agent's own —
 * `/home`, a `/w` picker and an `/o/:organizationId` surface — from when it was
 * a separate application, and nothing in this router answers any of those.
 */

/**
 * Where an authenticated viewer lands when nothing more specific was asked for;
 * the router forwards it to the account's first brand.
 */
export const APP_ENTRY_PATH = ENTRY

/** There is no workspace picker: the entry is where a person chooses a brand from. */
export const WORKSPACES_PATH = ENTRY

function isPathOrDescendant(pathname: string, root: string): boolean {
  return pathname === root || pathname.startsWith(`${root}/`)
}

/**
 * Whether a pathname belongs to the signed-in app — the entry or a brand — and
 * so requires a session before it renders.
 */
export function isAppSurfacePath(pathname: string): boolean {
  return pathname === ENTRY || isPathOrDescendant(pathname, '/w')
}
